var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgBackarr(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M15 6.99875H3.82998L8.70998 2.11875C9.09998 1.72875 9.09998 1.08875 8.70998 0.69875C8.31998 0.30875 7.68998 0.30875 7.29998 0.69875L0.70998 7.28875C0.31998 7.67875 0.31998 8.30875 0.70998 8.69875L7.29998 15.2888C7.68998 15.6788 8.31998 15.6788 8.70998 15.2888C9.09998 14.8988 9.09998 14.2687 8.70998 13.8787L3.82998 8.99875H15C15.55 8.99875 16 8.54875 16 7.99875C16 7.44875 15.55 6.99875 15 6.99875Z",
    fill: "#5B47F5"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgBackarr);
export default __webpack_public_path__ + "static/media/backarr.6b5037a847f69b2e71d2090ac3e11e04.svg";
export { ForwardRef as ReactComponent };